import { IFileImportService } from "@/services/backend/file_import/file_import.types";
import { handleResponse } from "@/services/handlers";
import {
  BACKEND_BASE_URL,
  IImportRecord,
  IImportsFilterParams,
  IPageResponse,
  IResponseError,
  serialize,
} from "@/services";
import Vue from "vue";
import { AxiosRequestConfig, AxiosResponse } from "axios";

export class FileImportService implements IFileImportService {
  async getTemplateFileImportServicepoint(): Promise<AxiosResponse<Blob> | undefined> {
    const postConfig = {
      headers: {
        Accept: "*/*",
        "X-Requested-With": "XMLHttpRequest",
      },
      responseType: "blob",
    } as AxiosRequestConfig;

    const { response, error } = await handleResponse<Blob, IResponseError>(
      Vue.$axios.get(
        `${BACKEND_BASE_URL}/api/configuration/v1/import/add-massive-servicepoint/template`,
        postConfig
      )
    );
    if (error || !response) {
      return undefined;
    }
    return response;
  }

  async addMassiveFileImportServicepoint(file: File): Promise<boolean> {
    const formData = new FormData();
    formData.append("file", file);
    const { error } = await handleResponse<void, IResponseError>(
      Vue.$axios.post(
        `${BACKEND_BASE_URL}/api/configuration/v1/import/add-massive-servicepoint`,
        formData
      )
    );
    return !error;
  }

  async getImports(
    params: IImportsFilterParams
  ): Promise<IPageResponse<IImportRecord> | undefined> {
    const { response, error } = await handleResponse<IPageResponse<IImportRecord>, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/import`, {
        params,
        paramsSerializer: (p) => serialize(p),
      })
    );
    if (error || !response) {
      return undefined;
    }
    return response.data;
  }

  async deleteImport(id: number): Promise<boolean> {
    const { error } = await handleResponse<void, IResponseError>(
      Vue.$axios.delete(`${BACKEND_BASE_URL}/api/configuration/v1/import/${id}`)
    );
    return !error;
  }

  async downloadImport(id: number): Promise<AxiosResponse<Blob> | undefined> {
    const { response, error } = await handleResponse<Blob, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/import/download/${id}`, {
        headers: { Accept: "*/*", "X-Requested-With": "XMLHttpRequest" },
        responseType: "blob",
      })
    );
    if (error || !response) {
      return undefined;
    }
    return response;
  }
}
